import React from "react";
import ToggleableButton from "../../../../../components/toggleableButton/toggleableButton";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/averageNumberOfVisitsPerClientSagas";

const OnlyMembership = () => {
  const dispatch = useDispatch();
  const {
    selectedFilters: { only_memberships }
  } = useSelector((state) => state.averageNumberOfVisitsPerClient);
  return (
    <ToggleableButton
      isActive={only_memberships}
      isRadio
      title="only_memberships"
      onClick={(data) => dispatch(actionCreators.updateOnlyMemberships(data))}
    />
  );
};

export default OnlyMembership;
